import { LocalStorageServiceModule } from './../local-storage/local-storage.module';
import { ScriptInjectorModule } from './../script-injector/script-injector.module';
import { NgModule } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { LoggerServiceModule } from '../logger/logger.module';

@NgModule({
	declarations: [],
	imports: [
		ScriptInjectorModule,
		LoggerServiceModule,
		LocalStorageServiceModule
	],
	exports: [ ],
	providers: [
		AnalyticsService
	]
})
export class AnalyticsModule {}
